module.exports = __webpack_public_path__ + "img/hr-heated-straight-vertical-6.72a4267d.png";